import { render, staticRenderFns } from "./ActionProfile.vue?vue&type=template&id=ca3fc80e&scoped=true"
import script from "./ActionProfile.vue?vue&type=script&lang=js"
export * from "./ActionProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3fc80e",
  null
  
)

export default component.exports